'use client'

/**
 * Карта продуктовых разделов VCENTRE.ONE.
 * Используется в навигации по платформе, в хедере/футере и в блоках «дальше».
 */

export interface ProductSection {
  to: string;
  label: string;
  hint: string;
  /** одна строка сути раздела */
  essence: string;
  /** роль раздела в общем контуре */
  role: string;
}

export const PRODUCT_SECTIONS: ProductSection[] = [
  {
    to: "/platform",
    label: "Обзор платформы",
    hint: "Как устроен единый контур",
    essence: "Как связаны клиенты, каналы, продажи и автоматизация.",
    role: "Объясняет целое",
  },
  {
    to: "/platform/crm",
    label: "CRM и клиенты",
    hint: "Профиль, заявки, сделки, задачи",
    essence: "Одна история клиента: обращения, сделки, задачи, документы.",
    role: "Где работает команда",
  },
  {
    to: "/platform/app",
    label: "Приложение компании",
    hint: "Готовое приложение уже с BASE",
    essence: "Стандартные страницы, каталог и ваш бренд — с расширением по мере роста.",
    role: "Свой клиентский канал",
  },
  {
    to: "/platform/websites",
    label: "Сайты",
    hint: "Полноценный сайт на выбор в PRO",
    essence: "Сайт с общей CRM и каталогом. Стандартное приложение сохраняется.",
    role: "Свой канал привлечения",
  },
  {
    to: "/platform/communications",
    label: "Коммуникации",
    hint: "Чаты, рассылки, push",
    essence: "Чат, клиент и сделка находятся рядом.",
    role: "Связь с клиентом",
  },
  {
    to: "/platform/automation-ai",
    label: "Автоматизация и AI",
    hint: "AI-помощь с BASE, бизнес-AI в GENIUS",
    essence: "Контент, помощь клиенту и AI для управления бизнесом на разных уровнях.",
    role: "Работа без ручных действий",
  },
  {
    to: "/platform/integrations",
    label: "Интеграции",
    hint: "1С, банки, внешние сервисы",
    essence: "Соединяем то, что уже работает в компании.",
    role: "Связь с инфраструктурой",
  },
  {
    to: "/platform/modules",
    label: "Расширения",
    hint: "Платные расширения под задачи",
    essence: "Специализированные системы для тех, кому они нужны.",
    role: "Расширение платформы",
  },
];

export const getSection = (to: string) => PRODUCT_SECTIONS.find((s) => s.to === to);
